// extracted by mini-css-extract-plugin
export default {"site":"day_site__3A4CU","homeLink":"day_homeLink__le1yo","header":"day_header__Pknsn","box":"day_box__XcQAw"};